import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet } from "react-router-dom";
import useApi from "../../hooks/useApi";
import useAvatar from "../../hooks/useAvatar";

const UserView = () => {
  const [client, setClient] = useState({});
  const { id } = useParams();
  const avatar = useAvatar(1);

  const { api, abortSignal, auth } = useApi();
  useEffect(() => {
    const callApi = async () => {
      try {
        const response = await api.read(`/users/${id}`);
        if (response) setClient(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [id, auth]);

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed rounded-0">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/users">Users</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {client?.name || id}
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}

          <h1 className="page-title mb-0 mt-2">
            {client?.name || "User detail"}
          </h1>

          <p className="lead">Detail view of User</p>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <div className="row">
            <div className="col-xxl-9 col-xl-8 col-lg-7 col-sm-12">
              {<Outlet />}
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-12">
              {/* <!-- User widget with background color --> */}
              <div className="card text-white mb-3">
                <div className="card-body">
                  {/* <!-- Profile picture and short information --> */}
                  <div className="text-center position-relative">
                    <div className="pt-2 pb-3">
                      <img
                        className="img-lg rounded-circle"
                        src={avatar}
                        alt="Profile Picture"
                        loading="lazy"
                      />
                    </div>
                    <span className="h5 stretched-link btn-link">
                      {client?.name || ""}
                    </span>
                    <p className="text-muted">{client.username}</p>
                  </div>
                  <div className="d-flex justify-content-center gap-2">
                    <a
                      href={`https://wa.me/233205607925`}
                      className="btn btn-sm btn-hover btn-outline-light"
                      target="_blank"
                    >
                      <i className="d-block demo-pli-technorati demo-pli-speech-bubble-2 text-muted fs-3 mb-2"></i>{" "}
                      Whatsapp
                    </a>
                    <a
                      href={`tel:${client.username}`}
                      className="btn btn-sm btn-hover btn-outline-light"
                    >
                      <i className="d-block demo-pli-consulting text-muted fs-3 mb-2"></i>{" "}
                      Call
                    </a>
                    <a
                      href={`mailto:${client.email}`}
                      className="btn btn-sm btn-hover btn-outline-light"
                    >
                      <i className="d-block demo-pli-mail text-muted fs-3 mb-2"></i>{" "}
                      Email
                    </a>
                    <Link
                      to="edit"
                      className="btn btn-sm btn-hover btn-outline-light"
                    >
                      <i className="d-block demo-pli-pen-5 text-muted fs-3 mb-2"></i>{" "}
                      Edit
                    </Link>
                  </div>
                  {/* <!-- END : Profile picture and short information --> */}
                </div>
              </div>
              {/* <!-- END : User widget with background color --> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserView;
